module.exports = {
  //交互反馈
  request: {
    201: "參數錯誤",
    202: "帳號不能為空",
    203: "密碼不能為空",
    204: "帳號錯誤",
    205: "密碼錯誤",
    206: "資訊錯誤，請聯系管理員",
    207: "幣種不存在",
    300: "請求失敗",
    208: "購買數量超出範圍",
    209: "密碼不一致",
    236: "帳號已存在",
    211: "原始密碼錯誤",
    212: "新密碼不能為空",
    213: "名稱不難為空",
    214: "姓氏不能為空",
    215: "請選擇證件類型",
    216: "證件號碼不能為空",
    217: "正面證件照不能為空",
    218: "反面證件照不能為空",
    219: "請選擇國籍",
    220: "手持證件照不能為空",
    221: "手持協議書不能為空",
    222: "餘額不足",
    223: "訂單錯誤，請聯繫管理員",
    230: "選擇的幣種不可以相同",
    234: "請使用正確的郵箱",
    235: "驗證碼不正確",
    237: "當前帳號暫未注册，請註冊",
    231: "選擇的幣種不能為空"
  },

  //国家
  country: {
    Usa: "美國",
    China: "中國",
    korea: "韓國",
    Japan: "日本",
    HongKong: "中國香港",
    Taiwan: "中國臺灣",
    Russia: "俄羅斯",
    France: "法国",
    britain: "英國",
    Germany: "德國",
    Brazil: "巴西",
    Italy: "義大利",
    Canada: "加拿大",
    Spain: "西班牙",
    Malaysia: "馬來西亞",
    Singapore: "新加坡",
    Indonesia: "印尼",
    Philippines: "菲律賓",
    Vietnam: "越南",
    India: "印度",
    Bhutan: "不丹",
    Finland: "芬蘭",
    Sweden: "瑞典",
    Norway: "挪威",
    Iceland: "冰島",
    Denmark: "丹麥",
    zimbabwe: "津巴布韋",
    Netherlands: "荷蘭",
    Thailand: "泰國",
  },

  //证件
  certificates: {
    passport: "護照",
    ID: "身份證",
    driverLicense: "駕駛證"
  },

  //通用
  currency: {
    loading: "加載中",
    determine: "確定",
    cancel: "取消",
    tips: "提示",
    psdRule: "密碼必須是字母+數位組合",
    psdLength: "密碼長度不得少於6比特",
    actionSuccess: "操作成功",
    loginPsdLength: "密碼長度不得少於8比特",
    success: "成功",
    fail: "失敗",
    passed: "稽核中",
    return: "返回"
  },

  // 登陆页
  login: {
    welComeToLogin: '歡迎登錄',
    username: "帳號",
    password: "密碼",
    submit: "提交",
    noAccount: "沒有帳號",
    register: "注册",
    forgetPassword: "忘記密碼",
    loginSuccess: "登入成功",
    logoutSuccess: "退出成功",
    enterAccount: "請輸入帳號",
    enterPsw: "請輸入密碼",
    rememberPassword: "記住密碼"
  },

  //注册页
  register: {
    registeredAccount: "註冊帳號",
    mailboxRegistration: "郵箱註冊",
    mailbox: "郵箱",
    setPassword: "設置密碼",
    confirmPassword: "確認密碼",
    readAgree: "我已閱讀並同意",
    userAgreement: "使用者協定",
    and: "和",
    privacyClause: "隱私條款",
    existingAccount: "已有帳號",
    signIn: '登入',
    registerSuccess: "注册成功",
    pleaseRead: "請先閱讀使用者協定和隱私條款",
    inviteCode: "邀請碼",
    verificationCode: "驗證碼"
  },

  //忘记密码
  forgetPassword: {
    code: "驗證碼",
    forgetPassword: "忘記密碼",
    sendCode: "發送驗證碼"
  },

  //顶部导航栏
  nav: {
    home: "首頁",
    quotation: "行情",
    transaction: "交易",
    notice: "公告",
    securityCenter: "安全中心",
    assets: "我的資產",
    recharge: "充值",
    withDrawal: "提現",
    fundTransfer: "資金劃轉",
    orderCenter: "訂單中心",
    exchange: "兌換",
    logOut: "登出",
    downloadApp: "掃碼下載APP",
    moreClient: "更多用戶端",
    chinese: "中文",
    english: "英语",
    korean: "韓文",
    japanese: "日文",
    traditionalChinese: "繁體",
    continueToExit: "是否繼續退出"
  },

  //首页
  home: {
    name: "名稱",
    price: '價格',
    amount: "今日漲跌",
    title: "交易，隨時隨地",
    desc: "多終端完美相容，隨時滿足各種場景的交易需求",
    text1: "隨時查看即時行情",
    text2: "輕鬆買賣BTC，ETH，XRP，OKB和其他數位資產",
    text3: "獲取您關注的加密貨幣價格變化預警",
    text4: "查看比特幣現貨、期貨、期權價格",
    text5: "比較各交易所加密貨幣價格",
    title1: "全球領先",
    title2: "數位資產服務平臺",
    desc2: "安全  ·  穩定  ·  可信",
    createAccount: "創建帳戶",
    text6: "開啟您的數位貨幣之旅"
  },

  //行情
  quotes: {
    title: "今日行情"
  },

  //安全中心
  securityCenter: {
    identityAuthentication: "身份認證",
    desc: "完成個人認證有助於保護帳戶安全，提高提現額度及交易許可權",
    go: "前往",
    loginPassword: "登入密碼",
    desc1: "用於保護帳戶安全",
    edit: "修改",
    fundPassword: '資金密碼',
    desc2: "用於保護資金安全",
    setUp: "設定",
    changePassword: "修改密碼",
    changePasswordAlert: "修改登入密碼後24小時內禁止提幣和OTC劃轉",
    originalPassword: "原密碼",
    newPassword: "新密碼",
    confirmPassword: "確認新密碼",
    setFundPassword: "設定資金密碼",
    resetFundPassword: "重置資金密碼",
    confirmFundPassword: "確認資金密碼",
    setSuccessfully: "設定成功"
  },

  //身份认证
  personalAuthentication: {
    identityAuthentication: "身份認證",
    personalIdentityAuthentication: "個人身份認證",
    know: "悉知",
    primaryCertification: "初級認證",
    desc: "新增提幣額度，24小時限額200BTC",
    advancedCertification: "高級認證",
    submitApproval: "提交審批",
    agreementDownload: '反洗錢協定下載',
    handCertificates: "請上傳手持證件照片",
    handCertificates2: "請上傳手持證件照片反洗錢協定照片",
    national: "國籍",
    surname: "姓",
    realname: "名",
    papersType: "證件類型",
    papers: "證件號",
    papersPositive: "請上傳正面照",
    papersReverse: "請上傳反面照",
    pleaseEnter: "請輸入",
    title: "為什麼我必須進行身份認證",
    content: "實名認證是為了遵守當前的金融法規或相關政策。實名認證更有助於保護您的帳戶安全，避免部分欺詐手段。我們將對您的資訊進行嚴格保密",
    title2: "暫時不支持哪些國家",
    content2: "實名認證是為了遵守當前的金融法規或相關政策。實名認證更有助於保護您的帳戶安全，避免部分欺詐手段。我們將對您的資訊進行嚴格保密",
    verificationCertification: "請先進行高級認證",
    authentication: "立即認證",
    PrimaryAuditPassed: "初級稽核通過",
    level0: "已注册",
    level1: "初級稽核中",
    level2: "初級稽核未通過",
    level3: "初級稽核通過",
    level4: "高級稽核中",
    level5: "高級稽核未通過",
    level6: "高級稽核通過",
  },

  //交易
  transaction: {
    pleaseSelect: "請選擇",
    price: "價格",
    requiredMargin: "所需保證金",
    closingFee: "平倉手續費",
    stopSurplus: "止盈",
    default: "默認",
    stopLoss: "止損",
    purchase: "買入",
    currentPosition: "現時持倉",
    historicalContract: "歷史合約",
    order: "訂單號",
    creationTime: "創建時間",
    transactionType: "交易類型",
    buyUp: "買漲",
    buyFall: "買跌",
    num: "數量",
    bond: "保證金",
    serviceCharge: "手續費",
    ClosingProfitLoss: "平倉盈虧",
    netProfitLoss: "淨盈虧",
    orderStatus: "訂單狀態",
    operation: "操作",
    compulsoryLiquidation: "強制平倉",
    forceClosing: "是否確定強制平倉?",
    pleaseLogin: "您暫未登錄，請先登錄！",
    buyCurrentPrice: "當前幣種價格為0",
    charged: "平倉時間",
    buildingTime: "建倉時間",
    buildingPrice: "建倉價格",
    currencyPriceNew: "平倉價格",
    heightPrice: "24h最高值",
    lowPrice: "24h最低值",
    latestTransaction: "最新成交",
    FloatingPL: "浮動盈虧",
    storageFee: "倉儲費",
    status1: "自動止盈平倉",
    status2: "自動止損平倉",
    status3: "手動止盈平倉",
    status4: "手動止損平倉",
    status5: "運行中",
  },


  assets: {
    accountOverview: "帳戶總覽",
    currencyAccount: "幣幣帳戶",
    contractAccount: "合約帳戶",
    transfer: "劃轉",
    withdrawMoney: "提幣",
    chargeMoney: "充幣",
    Cryptocurrency: "加密貨幣",
    currency: "貨幣",
    available: "可用",
    valuation: "估值",
    operation: "操作",
    chargingCurrency: "選擇充幣幣種",
    currencyType: "幣種",
    alert1: "最小充值金額",
    alert2: "小於最小金額的充值將不會上帳且無法退回",
    ChargingInfo: "確認幣種資訊",
    ChargingNetwork: "充幣網絡",
    rule2: "您充值至上述地址後，需要整個網絡節點的確認，12次網絡確認後到賬，12次網絡確認後可提幣。",
    rule3_btc: "最小充值金額：0.01BTC，小於最小金額的充值將不會上帳且無法退回。",
    rule3_usdt: "最小充值金額：300USDT，小於最小金額的充值將不會上帳且無法退回。",
    rule3_eth: "確認最小充值金額：0.15ETH，小於最小金額的充值將不會上賬且無法退回。",
    rule4: "您的充值地址不會經常改變，可以重複充值；如有變更，我們會盡量通過網站公告或郵件通知您。",
    rule5: "請務必確認電腦及瀏覽器安全，防止信息被篡改或洩露",
    ChargingRecord: "充幣記錄",
    time: "時間",
    netWorkAddress: "網絡地址",
    selectWithdrawalCurrency: "選擇提幣幣種",
    ol1: "為保障資金安全，當您賬戶安全策略變更，密碼修改，我們會對提幣進行人工審核，請耐心等待工作人員郵件聯繫。",
    ol2: "請務必確認電腦及瀏覽器安全，防止信息被篡改或洩露",
    withdrawalInfo: "填寫提幣信息",
    withdrawAddress: "提幣地址",
    withdrawalNetwork: "提幣網絡",
    withdrawalNum: "提幣數量",
    minWithdrawalNum: "最小提幣數量",
    actualArrival: "實際到賬",
    notLessThan: "不可小於",
    viewAll: "查看全部幣種",
    withdrawalRecord: "提幣記錄",
    transferCurrency: "請選擇劃轉幣種",
    transferNum: "劃轉數量",
    from: "從",
    to: "到",
    transferRecord: "劃轉記錄",
    exceedBalance: "不可大於可用數量",
    use: "使用",
    convertInto: "兌換成",
    exchangeRate: "匯率",
    exChangeAlert: "費率：2% | 曠工費自付",
    exchangeInstructions: "兌換須知",
    desc1: "請注意，資金兌換受市場深度和行情影響，價格將會隨時變化，請以訂單確認後的最終金額為準",
    desc2: "根據風控系統要求，資金兌換如果觸發第三方風控，兌換用戶需要配合審核員完善相關審核，如果無法完善審核，訂單會在至少一個月（30天）為您做退幣處理",
    desc3: "請您確保資金兌換屬於個人行為，並確認不使用數字貨幣參與任何傳銷，非法集資，詐騙等違法活動，請警惕一切許諾高額利息匯報的非法項目，謹防上當受騙，避免造成不必要的損失",
    exchangeRecord: "兌換記錄",
    useCurrency: "使用幣",
    exchangeCurrency: "兌換幣",
    AbsenteeismFee: "曠工費",
    exchangeQuantity: "兌換數量",
    paymentPassword: "請輸入支付密碼",
    currencyNoSame: "幣種不能相同"
  },

  // 二期
  iteration: {
    contractMarket: "合約市場",
    quotationDesc: "總覽數字貨幣行情",
    accountOverview: "賬戶總覽",
    accountOverviewDesc: "賬戶資金總覽",
    all: "全部",
    userCenter: "個人中心",
    viewInfo: "查看個人資料信息",
    setPsdDesc: "設置強度較高的密碼有利於賬戶安全",
    homeTitle: "全球第一的潛力幣交易所",
    homeDesc: "全球領先的上幣團隊，首發獨具價值的潛力幣",
    homeTitle2: "全球最大的社交化交易平台",
    homeDesc2: "和全球投資者在線交流，實時獲取高價值數字貨幣資訊",
    homeTitle3: "全民的交易所",
    homeDesc3: "服務於全球投資者，竭誠為不同文化、不同語言的用戶提供7*24小時無間斷的高品質服務",
    homeTitle4: "隨時隨地皆可交易",
    homeDesc4: "無論是APP還是WEB，都可以快速開啟您的交易",
    homeTitle5: "甚麼是比特幣？",
    homeDesc5: "比特幣是世界上最大、最著名的去中心化加密貨幣。 它採用區塊鏈作為底層技術，允許用戶通過點對點網絡傳輸數據和資產，且無需任何中間人和中央銀行。",
    homeTitle6: "1 美元可以購買數字資產嗎？",
    homeDesc6: "由於數字資產具有無限分割的特性，即使1美元也可以購買數字資產。",
    homeTitle7: "在 BitFuy 上交易安全嗎？",
    homeDesc7: "BitFuy及其團隊部署了全球最專業的安全網絡架構體系，並不斷優化和升級安全系統，以確保用戶資產和賬戶安全。",
    homeTitle8: "法定貨幣出入金是否有限制？",
    homeDesc8: "BitFuy嚴格遵守所在國的各項法律法規，不同國家的出入金規則不同。在法律允許的國家，BitFuy 對法定貨幣出入金不收取任何費用且沒有限制，",
    homeTitle9: "立即開啟您的數字貨幣之旅",
    homeDesc9: "BitFuy為您提供最便捷的數字貨幣交易方式",
    digitalCurrency: "數字貨幣",
    qualityInformation: "高質量咨詢",
    globalInvestor: "全球投資者",
    internationalCommunity: "國際社群",
    countriesCovered: "覆蓋國家",
    transactionText: "請充值數字貨幣或購買後進行交易",
    cumulative: "累計",
    realTimeTransaction: '實时成交',
    balance: "餘額",
    totalMargin: "總保證金",
    transferQuantityTips: "劃轉數量需大於0",
    notCertified: "未認證",
    certified: "已認證",
    underCertification: "認證中",
    digitalCurrencyTransactions: "數字貨幣交易",
    setCapitalPsw: "設置資金密碼",
    authenticationTips: "請進行初級認證",
    than: "數值需大於0"
  }
}